module.exports = __webpack_public_path__ + "img/Beifahrerseite_1T_C_Frontmotor.d8e3dc3e.jpg";